<script>
import ButtonAll from '../UI/Button/ButtonAll.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'

export default {
  components: { ButtonAll },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    document: { type: Object, required: true },
    haveBtn: { type: Boolean, required: false },
    uuid: { type: String, required: false },
    context: { type: String, default: 'documents' },
  },
  data: () => ({
    downloading: false,
  }),

  methods: {
    async download() {
      let url = ''
      if (this.uuid) {
        url += 'free/'
      }
      url += `${this.context + '/' + this.document.id + '/download' + (this.uuid ? `?uniqid=${this.uuid}` : '')}`

      let downloadName
      if (this.context !== 'documents') {
        downloadName = this.context + '-' + this.document.id + '.pdf'
      } else {
        downloadName = this.document.document.downloadName
      }

      this.downloading = true
      await this.downloadFile(url, downloadName)
      this.downloading = false
    },
  },
}
</script>
<template>
  <ButtonAll
    v-if="haveBtn"
    icon="download"
    type="download"
    size="small"
    margin="no"
    :loading="downloading"
    @click="download"
    name="documentDownload"
  />
  <ButtonAll
    v-else
    type="link"
    margin="no"
    class="content"
    style="font-size: 16px"
    :title="$t('document.clickForDownload')"
    :label="document.document.documentType.name + (document.name ? ' ' + document.name : '')"
    @click="download"
    name="documentDownload"
  />
</template>
